function appendToStorage(name, data){
    const { CATEGORIA, DESCRIPCION, IMAGEN, NOMBRE, PRECIO, PRECIOF, ID} = JSON.parse(data)
    var i = 0 
    var e = true
    var old = JSON.parse(localStorage.getItem(name));
    if (JSON.parse(localStorage.getItem("carrito")).length === 0){
        data = {
            cant: 1,
                desc: NOMBRE,
                id: ID,
                imagen: IMAGEN,
                precio: PRECIO,
                precioF: PRECIOF,
                subtotal: PRECIO
        }
        old.push(data)
        localStorage.setItem(name, JSON.stringify(old) );
    }
    else{
        for(; i < JSON.parse(localStorage.getItem("carrito")).length;){
            if(JSON.parse(localStorage.getItem("carrito"))[i].desc === NOMBRE){
                old[i].cant = old[i].cant+1
                old[i].subtotal = old[i].cant * old[i].precio
                localStorage.setItem(name, JSON.stringify(old) );
                e = false
            }
            i++
        }
        if(e){
            data = {
                cant: 1,
                desc: NOMBRE,
                id: ID,
                imagen: IMAGEN,
                precio: PRECIO,
                precioF: PRECIOF,
                subtotal: PRECIO
            }
            old.push(data)
            localStorage.setItem(name, JSON.stringify(old) );
        }
    }
}

export {appendToStorage};